import changeFace from './modules/changeFace';
import startingAnimation from './modules/startingAnimation';
import menuDropDown from './modules/menuDropDown';
import showHideMobileMenu from './modules/showHideMobileMenu';
import showAndHidePartFace from './modules/showAndHidePartFace';
import showSelfportrait from './modules/showSelfportrait';
import showSurprise from './modules/showSurprise';
import showMobilMainFace from './modules/showMobilMainFace';
import showSketch from './modules/showSketch';
import showFaceWorksMobil from './modules/showFaceWorksMobil';
import changeHeader from './modules/changeHeader';
import images from './modules/images';
import showCookies from './modules/showCookies';
import countdown from './modules/countdown';
//import slider from './modules/slider';


window.addEventListener('DOMContentLoaded', () => {
	
	'use strict';	

	if(document.documentElement.clientWidth <= 991){
		showHideMobileMenu();
		showMobilMainFace();
		showFaceWorksMobil();
	} else {
		menuDropDown();
	}		

	showAndHidePartFace('.main .face .item .worksBrain', '.main .faceBrain', '.main .faceBrain .item .worksBrainHide');
	showAndHidePartFace('.main .face .item .exhibitionLeftEye', '.main .faceLeftEye', '.main .faceLeftEye .item .exhibitionLeftEyeHide');	
	showAndHidePartFace('.main .face .item .galleryRightEye', '.main .faceRightEye', '.main .faceRightEye .item .galleryRightEyeHide');
	showAndHidePartFace('.main .face .item .websiteNose', '.main .faceNose', '.main .faceNose .item .websiteNoseHide');
	showAndHidePartFace('.main .face .item .newsEar', '.main .faceEarNews', '.main .faceEarNews .item .contactEarNewsHide');
	showAndHidePartFace('.main .face .item .contactEar', '.main .faceEar', '.main .faceEar .item .contactEarHide');
	showAndHidePartFace('.main .face .item .biographyMouth', '.main .faceMouth', '.main .faceMouth .item .biographyMouthHide');
	
	changeFace();
	showSelfportrait();
	showSurprise();		
	showSketch();	
	startingAnimation();
	//slider('.container .slider .slider-item', '.container .slider .prevArrow', '.container .slider .nextArrow');

	changeHeader('.exhibition');
	// changeHeader('.main');
	// changeHeader('.face-works-mobil');
	// changeHeader('.prehistory');

	images();
	countdown();
	showCookies();	
});
